var map = {
	"./dog.webp": 5392,
	"./exodo_off.webp": 246,
	"./exodo_on.webp": 8226,
	"./fernando.webp": 1459,
	"./icons/Bootstrap.webp": 7988,
	"./icons/CSS.webp": 8586,
	"./icons/Firebase.webp": 4562,
	"./icons/HTML.webp": 8687,
	"./icons/JavaScript.webp": 1448,
	"./icons/MySQL.webp": 9214,
	"./icons/NextJS.webp": 2840,
	"./icons/React Router.webp": 2607,
	"./icons/React.webp": 9075,
	"./icons/Redux.webp": 9381,
	"./icons/Sass.webp": 1111,
	"./icons/Tailwind CSS.webp": 3092,
	"./icons/Testing Library.webp": 6162,
	"./icons/TypeScript.webp": 9384,
	"./icons/cv.webp": 5297,
	"./icons/cv_ok.webp": 4427,
	"./icons/deploy.webp": 5397,
	"./icons/github.webp": 5834,
	"./icons/github_2.webp": 7114,
	"./icons/linkedin.webp": 9119,
	"./icons/music/applemusic.webp": 5454,
	"./icons/music/spotify.webp": 4632,
	"./icons/music/ytmusic.webp": 1600,
	"./icons/void.webp": 9676,
	"./pomodoro.webp": 9827,
	"./recipes.webp": 9455,
	"./simon.webp": 2809,
	"./space.webp": 6960,
	"./supermarket.webp": 9241,
	"./tremolo.webp": 4685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;